import { AdvancedImage } from "@cloudinary/react";
import React from "react";
import Carousel from "../../../../components/Carousel/Carousel";
import Loading from "../../../../components/Loading/Loading";
import Wrapper from "../../../../components/Wrapper/Wrapper";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import { locale } from "../../../../utilities/locale/locale";
import localeText from "../../../../locale";
import { Skeleton } from "primereact/skeleton";
import useLoadingSimulation from "../../hooks/useLoadingSimulation";

const CategoryTemplate = ({ selectedCategory, category, onClick }) => {
  const descriptions = {
    en: category.descriptionEnglish,
    it: category.descriptionItalian,
    pt: category.descriptionPortuguese,
    es: category.descriptionSpanish,
  };
  const description = descriptions[locale] ?? "";
  const baseClass =
    "category-template flex flex-column justify-content-end relative gap-2 cursor-pointer transition-colors transition-duration-500 border-round-lg ";

  const handleSelectedCategory = () => {
    onClick({
      ...category,
      descriptionCurrentLocale: description ? description : category.descriptionEnglish,
    });
  };

  return (
    <div
      className={`${baseClass} ${selectedCategory?.id === category.id ? "bg-green-100" : ""}`}
      onClick={handleSelectedCategory}
      style={{ backgroundColor: "#D9F7EC" }}
    >
      <AdvancedImage
        className="absolute"
        style={{
          maxHeight: "150px",
          maxWidth: "150px",
          top: "-40px",
          left: "50%",
          transform: "translateX(-50%)",
        }}
        cldImg={cloudinaryInstance.image(category.imageid).format("webp")}
      />
      {/*  <div className="" style={{height: "50%"}}></div> */}
      <div className="flex flex-column justify-content-center" style={{ height: "50%" }}>
        <div className="text-center font-semibold px-3" style={{ color: "#204C21" }}>
          {description ? description : category.descriptionEnglish}
        </div>
      </div>
    </div>
  );
};

const SectionCategories = ({
  categories,
  loadingCategories,
  selectedCategory,
  handleSelectedCategory,
}) => {
  const isLoadingSimulation = useLoadingSimulation();
  if (loadingCategories)
    return (
      <>
        <Skeleton width="15rem" className="mt-8 mb-4" />
        <div className="flex gap-2 carousel-view">
          {[...Array(7)].map((_, i) => (
            <div key={i} className="skeleton-wrapper">
              <Skeleton size="10rem" />
            </div>
          ))}
        </div>
      </>
    );

  return (
    <div className="surface-0 mt-8">
      <div className="font-bold text-2xl text-primary">{localeText("selectCategory")}</div>
      <Wrapper classnames="h-13rem surface-0 flex justify-content-center align-items-center relative w-full">
        <Carousel

          items={categories.map((category) => (
            <CategoryTemplate
              selectedCategory={selectedCategory}
              category={category}
              onClick={handleSelectedCategory}
            />
          ))}
        />
      </Wrapper>
    </div>
  );
};

export default SectionCategories;
